define([
    'document-ready-promise',
    'jquery'
], function(ready, $) {

    var contact = {
        init: function() {
            contact.attachOtherSwitch();
            contact.initMap();
        },

        attachOtherSwitch: function() {
            $('#other-container').toggle($('#reason-other').is(':checked'));

            $('#reason-other').change(function() {
                $('#other-container').toggle($('#reason-other').is(':checked'));    
            });
        },


        initMap: function() {
            var location = {lat: -27.471421, lng: 153.027773};

            var map = new google.maps.Map(document.getElementById('map-canvas'), {
                zoom: 15,
                center: location,
                styles: contact.mapStyles,
                mapTypeControl: false,
                zoomControl: false,
                scaleControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });

            var marker = new google.maps.Marker({
                position: location,
                map: map,
                icon: '/img/marker-orange.png'
            });

        },

        mapStyles: [{
            'elementType': 'geometry',
            'stylers': [{
                'color': '#ebe3cd'
            }]
        }, {
            'elementType': 'labels.text.fill',
            'stylers': [{
                'color': '#523735'
            }]
        }, {
            'elementType': 'labels.text.stroke',
            'stylers': [{
            'color': '#f5f1e6'
            }]
        }, {
            'featureType': 'administrative',
            'elementType': 'geometry',
            'stylers': [{
                'visibility': 'off'
            }]
        }, {
            'featureType': 'administrative',
            'elementType': 'geometry.stroke',
            'stylers': [{
                'color': '#c9b2a6'
            }]
        }, {
            'featureType': 'landscape.man_made',
            'stylers': [{
                'visibility': 'off'
            }]
        }, {
            'featureType': 'landscape.man_made',
            'elementType': 'geometry.fill',
            'stylers': [{
                'color': '#fffaf5'
            }, {
                'visibility': 'off'
            }]
        }, {
            'featureType': 'landscape.natural',
            'elementType': 'geometry',
            'stylers': [{
                'visibility': 'off'
            }]
        }, {
            'featureType': 'landscape.natural',
            'elementType': 'geometry.fill',
            'stylers': [{
                'visibility': 'simplified'
            }]
        }, {
            'featureType': 'poi',
            'stylers': [{
                'visibility': 'off'
            }]
        }, {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [{
                'color': '#dfd2ae'
            }]
        }, {
            'featureType': 'poi',
            'elementType': 'labels.text.fill',
            'stylers': [{
                'color': '#93817c'
            }]
        }, {
            'featureType': 'road',
            'elementType': 'geometry',
            'stylers': [{
                'color': '#afadab'
            }, {
                'weight': 0.8
            }]
        }, {
            'featureType': 'road',
            'elementType': 'geometry.fill',
            'stylers': [{
                'color': '#aaa9a7'
            }]
        }, {
            'featureType': 'road',
            'elementType': 'labels.icon',
            'stylers': [{
                'visibility': 'off'
            }]
        }, {
            'featureType': 'road.arterial',
            'elementType': 'geometry',
            'stylers': [{
                'color': '#fdfcf8'
            }]
        }, {
            'featureType': 'road.arterial',
            'elementType': 'geometry.fill',
            'stylers': [{
                'color': '#92918f'
            }]
        }, {
            'featureType': 'road.highway',
            'elementType': 'geometry',
            'stylers': [{
                'color': '#f8c967'
            }]
        }, {
            'featureType': 'road.highway',
            'elementType': 'geometry.fill',
            'stylers': [{
                'color': '#aaa9a7'
            }]
        }, {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers': [{
                'color': '#e2d9db'
            }]
        }, {
            'featureType': 'road.highway.controlled_access',
            'elementType': 'geometry',
            'stylers': [{
                'color': '#e98d58'
            }]
        }, {
            'featureType': 'road.highway.controlled_access',
            'elementType': 'geometry.fill',
            'stylers': [{
                'color': '#aaa9a7'
            }]
        }, {
            'featureType': 'road.highway.controlled_access',
            'elementType': 'geometry.stroke',
            'stylers': [{
                'color': '#808787'
            }, {
                'visibility': 'off'
            }]
        }, {
            'featureType': 'road.local',
            'elementType': 'labels.text.fill',
            'stylers': [{
                'color': '#806b63'
            }]
        }, {
            'featureType': 'transit',
            'stylers': [{
                'visibility': 'off'
            }]
        }, {
            'featureType': 'water',
            'elementType': 'geometry.fill',
            'stylers': [{
                'color': '#88e4ff'
            }]
        }]

    };

    ready().then(function(){
        contact.init();
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/contact/contact.js